// extracted by mini-css-extract-plugin
export var barcodeInput = "BarcodeInput-module--barcodeInput--4ZTzT";
export var barcodeScanButton = "BarcodeInput-module--barcodeScanButton--87ME9";
export var barcodeScanButtonXs = "BarcodeInput-module--barcodeScanButtonXs--woUxE";
export var buttonContainer = "BarcodeInput-module--buttonContainer--+S96V";
export var inputField = "BarcodeInput-module--inputField--CwlAL";